module.exports = ".labelWrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: white;\n  border-radius: 6px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/inp/inp.component.scss
// module id = ./src/app/inp/inp.component.scss
// module chunks = main